function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? Object(arguments[r]) : {}, o = Object.keys(t); "function" == typeof Object.getOwnPropertySymbols && o.push.apply(o, Object.getOwnPropertySymbols(t).filter(function (e) { return Object.getOwnPropertyDescriptor(t, e).enumerable; })), o.forEach(function (r) { _defineProperty(e, r, t[r]); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from 'react';
import '../TextInput/TextInput.css';
import './Textarea.css';
import cs from 'classnames';
import whitelistProps from '../../utils/whitelistProps';
import compose from '../../utils/compose';
import { default as withInputContainer } from '../withInputContainer/withInputContainer';
import { injectIntl } from 'react-intl';
import getLabelId from '../getLabelId';
import ThemeContext from '../../ThemeContext/ThemeContext';
var whitelist = whitelistProps();
export function Textarea(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'textarea' : _ref$type,
    auto = _ref.auto,
    _ref$displayCharCount = _ref.displayCharCount,
    displayCharCount = _ref$displayCharCount === void 0 ? false : _ref$displayCharCount,
    label = _ref.label,
    labelIcons = _ref.labelIcons,
    iconIds = _ref.iconIds,
    labelHidden = _ref.labelHidden,
    descriptionId = _ref.descriptionId,
    errorId = _ref.errorId,
    errorMsg = _ref.errorMsg,
    width = _ref.width,
    _ref$resize = _ref.resize,
    resize = _ref$resize === void 0 ? 'vertical' : _ref$resize,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'small' : _ref$size,
    id = _ref.id,
    value = _ref.value,
    name = _ref.name,
    style = _ref.style,
    required = _ref.required,
    disabled = _ref.disabled,
    readonly = _ref.readonly,
    placeholder = _ref.placeholder,
    minLength = _ref.minLength,
    maxLength = _ref.maxLength,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    onFocus = _ref.onFocus,
    intl = _ref.intl,
    attrs = _objectWithoutProperties(_ref, ["type", "auto", "displayCharCount", "label", "labelIcons", "iconIds", "labelHidden", "descriptionId", "errorId", "errorMsg", "width", "resize", "size", "id", "value", "name", "style", "required", "disabled", "readonly", "placeholder", "minLength", "maxLength", "onBlur", "onChange", "onFocus", "intl"]);
  var styl = _objectSpread({
    width: width,
    resize: disabled ? 'none' : resize
  }, style);
  var theme = useContext(ThemeContext);
  var className = cs("_dm-input _dm-input--".concat(size), "_dm-input--textbox _dm-input--textbox--".concat(size), "_dm-input--textarea _dm-input--textarea--".concat(size), "_dm-input--".concat(theme, "--").concat(type, " _dm-input--").concat(theme, "--").concat(type, "--").concat(size), "auto-textarea-input", _defineProperty(_defineProperty({}, auto, auto), '_dm-input--textarea__charCount', displayCharCount));
  if (disabled) {
    return /*#__PURE__*/React.createElement("p", {
      id: id,
      className: className,
      style: styl,
      disabled: disabled,
      role: "textbox",
      "aria-disabled": disabled,
      "aria-labelledby": getLabelId(id)
    }, value);
  }
  if (displayCharCount && theme === 'ripple') {
    return /*#__PURE__*/React.createElement(TextareaWithCharacterCount, {
      attrs: attrs,
      className: className,
      descriptionId: descriptionId,
      disabled: disabled,
      errorId: errorId,
      errorMsg: errorMsg,
      iconIds: iconIds,
      id: id,
      intl: intl,
      maxLength: maxLength,
      minLength: minLength,
      name: name,
      onBlur: onBlur,
      onChange: onChange,
      onFocus: onFocus,
      placeholder: placeholder,
      readonly: readonly,
      required: required,
      styl: styl,
      type: type,
      value: value
    });
  }
  return /*#__PURE__*/React.createElement("textarea", Object.assign({
    id: id,
    value: value,
    name: name,
    className: className,
    type: type,
    style: styl,
    required: required,
    "aria-required": !!required,
    disabled: disabled,
    "aria-disabled": disabled,
    readOnly: readonly,
    "aria-readonly": readonly,
    placeholder: placeholder ? intl.formatMessage({
      id: placeholder
    }) : '',
    minLength: minLength,
    maxLength: maxLength,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    "aria-describedby": "".concat(iconIds, " ").concat(errorId, " ").concat(descriptionId),
    "aria-invalid": !!errorMsg,
    "aria-errormessage": errorId
  }, whitelist(attrs)));
}
export default compose(injectIntl, withInputContainer({
  metaType: 'textbox',
  type: 'textarea'
}))(Textarea);
function TextareaWithCharacterCount(_ref2) {
  var attrs = _ref2.attrs,
    className = _ref2.className,
    descriptionId = _ref2.descriptionId,
    disabled = _ref2.disabled,
    errorId = _ref2.errorId,
    errorMsg = _ref2.errorMsg,
    iconIds = _ref2.iconIds,
    id = _ref2.id,
    intl = _ref2.intl,
    maxLength = _ref2.maxLength,
    minLength = _ref2.minLength,
    name = _ref2.name,
    onBlur = _ref2.onBlur,
    onChange = _ref2.onChange,
    onFocus = _ref2.onFocus,
    placeholder = _ref2.placeholder,
    readonly = _ref2.readonly,
    required = _ref2.required,
    styl = _ref2.styl,
    type = _ref2.type,
    value = _ref2.value;
  var charCount = !!value && typeof value === 'string' ? value.length : 0;
  return /*#__PURE__*/React.createElement("div", {
    className: "_dm-container--textarea__charCount"
  }, /*#__PURE__*/React.createElement("textarea", Object.assign({
    id: id,
    value: value,
    name: name,
    className: className,
    type: type,
    style: styl,
    required: required,
    "aria-required": !!required,
    disabled: disabled,
    "aria-disabled": disabled,
    readOnly: readonly,
    "aria-readonly": readonly,
    placeholder: placeholder ? intl.formatMessage({
      id: placeholder
    }) : '',
    minLength: minLength,
    maxLength: maxLength,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    "aria-describedby": "".concat(iconIds, " ").concat(errorId, " ").concat(descriptionId),
    "aria-invalid": !!errorMsg,
    "aria-errormessage": errorId
  }, whitelist(attrs))), /*#__PURE__*/React.createElement("div", {
    className: "textarea-charCount-bar"
  }, charCount, "/", maxLength));
}